import {ValidatorFn} from '@angular/forms';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildAsyncValidators, buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import {ChipsMultiSelectFieldConfig} from './chips-multiselect-field.config';

export const chipsMultiSelectFieldControlBuilder: ControlBuilder = (fieldConfig: ChipsMultiSelectFieldConfig, formBuilder) => {
    const {disabled, value} = fieldConfig;

    const validators = buildChipsMultiSelectFieldValidators(fieldConfig);
    const asyncValidators = buildAsyncValidators(fieldConfig);

    return formBuilder.control(
        {
            disabled,
            value: value || null
        },
        validators,
        asyncValidators
    );
};

export const buildChipsMultiSelectFieldValidators: (fieldConfig: ChipsMultiSelectFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        return buildDefaultValidators(config);
    };
